import React, { Fragment, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./styles.scss";
import { useSelector } from "react-redux";
import { ReactComponent as CloseXIcon } from "../../public/icons/close-x-icon.svg";
import { listCountries } from "../../api/location";
import states from "../../public/locals/states.json";
import { Spinner } from "react-bootstrap";
import { inviteFriends } from "../../api/invite_friends";
import { updateCurrentUser } from "../../api/users";

const ModelContainer = ({ title, description, show, handleClose }) => {
  const { current_user } = useSelector(({ current_user }) => ({
    current_user,
  }));

  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [paypalEmail, setPaypalEmail] = useState(current_user?.artist_profile?.paypal_me_tag);
  /*
  //---------- state and veriables
  const [emails, setEmails] = useState([]);
  const [errorsInEmails, setErrorsInEmails] = useState([]);
  const [emailErrors, setEmailErrors] = useState([]);
  const [nameErrors, setNameErrors] = useState([]);
  const [names, setNames] = useState([]);
  const [otherError, setOtherError] = useState({});
  const [address, setAddress] = useState({});
  const [dropDwonSelected, setDropDwonSelected] = useState({});
  const [isCityRequired, setIsCityRequired] = useState(false);
  const [update_for_name_input, setUpdate_for_name_input] = useState(false);
  const [countries, setCountries] = useState("");
  
  //---------- constants
  // const idArray = [0, 1, 2, 3, 4];
  const idArray = [0];
  let sizes = [
    // { title: "Pick Your Size", id: 0, sulg_id: "pick your size" },
    { title: "small", id: 1, sulg_id: "small" },
    { title: "medium", id: 2, sulg_id: "medium" },
    { title: "large", id: 3, sulg_id: "large" },
    { title: "XL", id: 4, sulg_id: "XL" },
    { title: "XXL", id: 5, sulg_id: "XXl" },
  ];

  //---------- life cycles

  useEffect(() => {
    listCountries(["name", "alpha2Code"]).then(({ data }) => {
      let countries = data.data.sort((a, b) => (a.name === "United States of America" ? -1 : 0));
      countries = countries.map((c) => ({
        ...c,
        name: c.alpha2Code === "GB" ? "United Kingdom" : c.name,
      }));
      setCountries(countries);
    });
    setDropDwonSelected({
      ...dropDwonSelected,
      ["country"]: current_user?.address?.country,
    });
  }, []);

  //---------- helper : user action

  const handleClickDropDown = (key, data) => {
    setServerError(null);
    setSuccessMessage(null);
    if (key === "country") {
      clearError("country_error");
      if (data === "United States of America") {
        setIsCityRequired(true);
      } else {
        setIsCityRequired(false);
      }
      setDropDwonSelected({
        ...dropDwonSelected,
        [key]: data,
      });
    } else {
      if (key === "province") {
        clearError("province_error");
      }
      if (key === "size") {
        clearError("size_error");
      }
      setDropDwonSelected({
        ...dropDwonSelected,
        [key]: data,
      });
    }
  };

  const onChange = (text, type, id) => {
    setServerError(null);
    setSuccessMessage(null);

    if (type === "email") {
      let email_array = emails;
      let email_errors_array = emailErrors;
      email_array[id] = text;
      email_errors_array[id] = null;
      setEmails(email_array);
      setEmailErrors(email_errors_array);
    } else if (type === "address") {
      if (id === "zipcode") {
        clearError("zipcode_error");

        // var reg = /^\d+$/;

        if (text) {
          // if (reg.test(text) === true) {
          if (text.length <= 6) {
            current_user.address.zip = text;
            setAddress({
              ...address,
              [id]: text,
            });
          }
          // }
        } else {
          current_user.address.zip = text;
          setAddress({
            ...address,
            [id]: text,
          });
        }
      } else {
        if (id === "first_name") {
          current_user.first_name = text;
        }
        if (id === "last_name") {
          current_user.last_name = text;
        }

        if (id === "province") {
          current_user.address.state = text;
        }
        if (id === "city") {
          current_user.address.city = text;
        }
        if (id === "address_1") {
          current_user.address.address_1 = text;
        }
        if (id === "address_2") {
          current_user.address.address_2 = text;
        }
        let new_text = text.replace(/[^a-zA-Z0-9 ]/g, "");
        // let new_text = text.replace(/[^a-zA-Z ]/g, ""); // only character input

        setAddress({
          ...address,
          [id]: new_text,
        });
      }
    } else {
      let name_array = names;
      let name_errors_array = nameErrors;
      name_errors_array[id] = null;
      let new_text = text.replace(/[^a-zA-Z0-9 ]/g, "");
      // let new_text = text.replace(/[^a-zA-Z ]/g, ""); // only character input
      name_array[id] = new_text;
      // current_user.last_name = text
      setNames(name_array);
      setNameErrors(name_errors_array);
      // its update because all of the name in array
    }
    setUpdate_for_name_input(!update_for_name_input);
    if (id === "first_name") {
      clearError("first_name_error");
    }
    if (id === "last_name") {
      clearError("last_name_error");
    }
    if (id === "address_1") {
      clearError("address_error");
    }
    if (id === "province") {
      clearError("province_error");
    }
    if (id === "city") {
      clearError("city_error");
    }
  };

  // validate and submit for invite friends
  const handleClickInviteNow = async () => {
    let email_errors_array = emailErrors;
    let name_errors_array = nameErrors;
    let error = {};
    let isError = false;

    if (emails?.length > 0 || names?.length > 0) {
      for (var i = 0; i < idArray.length; i++) {
        let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;

        if (reg.test(emails[i]) === false) {
          email_errors_array[i] = "Email is not correct";
          isError = true;
        }
        if (!emails[i]) {
          email_errors_array[i] = "Email is required!";
          isError = true;
        }
      }
    } else {
      for (var i = 0; i < idArray.length; i++) {
        email_errors_array[i] = "Email is required!";
        // name_errors_array[i] = "Name is required!";
        isError = true;
      }
    }

    // if (names?.length == 0) {
    //   for (var i = 0; i < idArray.length; i++) {
    //     name_errors_array[i] = "name is required!";
    //     // name_errors_array[i] = "Name is required!";
    //     isError = true;
    //   }
    // }

    if (!dropDwonSelected?.size) {
      error.size_error = "Size is required!";
      isError = true;
    }

    if (!dropDwonSelected?.country) {
      error.country_error = "Country is required!";
      isError = true;
    }

    if (current_user?.first_name?.length == 0 || current_user?.first_name?.length == null) {
      error.first_name_error = "First name is required!";
      isError = true;
    }

    if (current_user?.last_name?.length == 0 || current_user?.last_name?.length == null) {
      error.last_name_error = "Last name is required!";
      isError = true;
    }

    if (current_user?.address.address_1?.length == 0 || current_user?.address.address_1?.length == null) {
      error.address_error = "Address is required!";
      isError = true;
    }

    if (current_user?.address.zip == 0 || current_user?.address.zip == null) {
      error.zipcode_error = "Zip/Postal Code is required!";
      isError = true;
    }

    if (current_user?.address.city?.length == 0 || current_user?.address.city?.length == null) {
      error.city_error = "City is required!";
      isError = true;
    }

    if (isCityRequired) {
      if (current_user?.address?.state?.length == 0) {
        error.province_error = "State/Province is required!";
        isError = true;
      }
    } else {
      if (current_user?.address?.state?.length == 0 || current_user?.address?.state?.length == null) {
        error.province_error = "State/Province is required!";
        isError = true;
      }
    }

    if (isError) {
      setEmailErrors(email_errors_array);
      setNameErrors(name_errors_array);
      setOtherError({ ...error });
    } else {
      let data_obj = {
        tshirt_info: {
          first_name: current_user?.first_name,
          last_name: current_user?.last_name,
          size: dropDwonSelected?.size,
          address_line: address?.address,
          address_attributes: {
            city: current_user?.address.city,
            state: isCityRequired ? dropDwonSelected.province : current_user?.address?.state,
            country: dropDwonSelected.country,
            zip: address?.zipcode ? address?.zipcode : current_user.address.zip,
            address1: address?.address_1 ? address?.address_1 : current_user.address.address_1,
            address2: address?.address_2 ? address?.address_2 : current_user.address.address_2,
          },
          invited_friends_attributes: [],
        },
      };

      for (let i = 0; i < idArray.length; i++) {
        let obj = {
          name: names[i],
          email: emails[i],
        };
        data_obj.tshirt_info.invited_friends_attributes.push(obj);
      }

      let server_error;
      let server_respones;
      let err_emails_array = [];

      try {
        server_respones = await serverRequst(data_obj);
      } catch (error) {
        console.log("error :", error);
        console.log("error :", error?.response);

        // server_error = error?.response?.data;
        server_error =
          error?.response?.data?.errors ||
          (error?.response?.data?.errors.length > 0 && error?.response?.data?.errors[0]?.message) ||
          "server detect an error...";
        if (error?.response?.data?.email_arr?.length > 0) {
          err_emails_array = error?.response?.data?.email_arr;
        } else {
          err_emails_array = [];
        }

        // let emails;
        // if (error?.response?.data?.email_arr?.length > 0) {
        //   for (var i = 0; i < error?.response?.data?.email_arr?.length; i++) {
        //     emails = emails
        //       ? `${emails} <p className="email">${error?.response?.data?.email_arr[i]}</p>`
        //       : `<p className="email">${error?.response?.data?.email_arr[i]}</p>`;

        //     if (i === error?.response?.data?.email_arr?.length - 1) {
        //       emails = `${emails} ! ${error?.response?.data?.errors}`;
        //     }
        //   }
        //   server_error = emails;
        // } else {
        //   server_error =
        //     error?.response?.data?.errors[0]?.message ||
        //     "server detect an error...";
        // }
      }

      if (server_respones) {
        setLoading(false);
        clearPreviousPocket();
        setSuccessMessage("Your Request Successfully Submitted!");
        // handleClose();
      }

      if (server_error) {
        setErrorsInEmails(err_emails_array);
        setServerError(server_error);
        setLoading(false);
      }
    }
  };

  //---------- helper : render

  const renderEmailInput = (id) => {
    let isError;

    if (errorsInEmails.length > 0) {
      for (var i = 0; i < errorsInEmails.length; i++) {
        if (errorsInEmails[i] === emails[id]) {
          isError = true;
        }
      }
    }

    return (
      <input
        className={isError ? "email-input-err" : "email-input"}
        id={id}
        value={emails[id] || ""}
        type={"email"}
        placeholder={"your.friend@email.com"}
        onChange={(e) => onChange(e.target.value, "email", id)}
      />
    );
  };

  const renderNameInput = (id) => {
    return (
      <input
        className={"name-input"}
        id={id}
        value={names[id] || ""}
        type={"text"}
        placeholder={"DJ Magic, The Lumineers, Niki, etc."}
        onChange={(e) => onChange(e.target.value, "name", id)}
      />
    );
  };

  const renderInputWithLabel = (title, placeholder, id, value) => {
    return (
      <div style={{ marginTop: 20 }}>
        <p className={"input-title"}>{title}</p>
        {value == null ? (
          <input
            className={"address-input"}
            id={title}
            type={"text"}
            placeholder={placeholder || title}
            onChange={(e) => onChange(e.target.value, "address", id)}
          />
        ) : (
          <input
            className={"address-input"}
            id={title}
            value={value || ""}
            type={"text"}
            placeholder={placeholder || title}
            onChange={(e) => onChange(e.target.value, "address", id)}
          />
        )}
      </div>
    );
  };

  const renderInputWithLabelName = (title, placeholder, id, name_value) => {
    return (
      <div style={{ marginTop: 20 }}>
        <p className={"input-title"} style={id === "last_name" ? { marginLeft: 30 } : {}}>
          {title}
        </p>
        <input
          className={id === "first_name" ? "email-input" : "name-input"}
          id={title}
          value={name_value || ""}
          type={"id"}
          placeholder={placeholder || title}
          onChange={(e) => onChange(e.target.value, "address", id)}
        />
      </div>
    );
  };

  // call when you want to clear data
  const clearPreviousPocket = () => {
    setEmails([]);
    setEmailErrors([]);
    setErrorsInEmails([]);
    setNameErrors([]);
    setNames([]);
    setOtherError({});
    // setCountries("");
    setIsCityRequired(false);
    setLoading(false);
    setUpdate_for_name_input(false);
    setServerError(null);
  };

  const clearError = (type) => {
    setOtherError({
      ...otherError,
      [type]: null,
    });
  };
  */

  // server request
  const serverRequst = (data) => {
    setLoading(true);
    return inviteFriends(data);
  };

  const renderEmailName = () => {
    return (
      <div className={"input-container"}>
        <input
          required
          className={"email-input"}
          type={"email"}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={"your.friend@email.com"}
        />
        <input
          required
          className={"name-input"}
          type={"text"}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={"DJ Magic, The Lumineers, Niki, etc."}
        />
      </div>
    );
  };

  const handleClickInviteNow = (e) => {
    e.preventDefault();

    if (!loading) {
      setServerError(null);
      setSuccessMessage(null);
      const data_obj = {
        invite_info: {
          name,
          email,
          paypal: paypalEmail,
        },
      };

      serverRequst(data_obj)
        .then(() => {
          setSuccessMessage("Awesome, thanks for sharing UNIFI! Want to invite someone else?");
        })
        .catch((server_error) => {
          setServerError(server_error);
        })
        .finally(() => {
          setLoading(false);
        });

      updateCurrentUser({
        user: {
          artist_profile: {
            paypal_me_tag: paypalEmail,
          },
        },
      });
    }

    return false;
  };

  return (
    <Modal
      className="primo"
      size="lg"
      show={show}
      onHide={() => {
        // clearPreviousPocket();
        handleClose();
      }}
    >
      <div className="d-flex justify-content-end align-items-end p-3 invited-close">
        <CloseXIcon
          className="close-icon"
          onClick={() => {
            // clearPreviousPocket();
            handleClose();
          }}
        />
      </div>
      <Modal.Body className="text-center p-5 invite-model-body">
        {successMessage ? (
          <div className="mt-4">
            <strong style={{ fontSize: 20 }} className={"success-msg"}>
              {successMessage}
            </strong>
            <div>
              <button
                className={"btn-btn-invite-submit"}
                style={{ border: "none" }}
                onClick={() => {
                  setEmail(null);
                  setName(null);
                  setSuccessMessage(null);
                }}
              >
                Invite Another
              </button>
            </div>
          </div>
        ) : (
          <>
            <Modal.Title as="h1" className="text-dark font-weight-bold model-invite-title">
              {title}
            </Modal.Title>
            <form onSubmit={handleClickInviteNow}>
              <div className={"description"}>{description}</div>
              <div className={"invite-friend-list mt-4"}>
                <p>Friend To Invite</p>
                <div className={"content-container"}>
                  {renderEmailName()}
                  {/* <div className={"input-container"}>
                  <div style={{ width: "50%" }}>
                    {emailErrors?.length > 0 && emailErrors[id] && <p className={"email-error"}>{emailErrors[id]}</p>}
                  </div>
                  <div style={{ width: "50%" }}>{nameErrors?.length > 0 && nameErrors[id] && <p className={"name-error"}>{nameErrors[id]}</p>}</div>
                </div> */}
                </div>

                <div className={"content-container d-flex flex-row align-items-start"}>
                  <label className="mb-0 mr-2" style={{ whiteSpace: "nowrap" }} htmlFor="artist_profile_attributes[artist_type]">
                    Your PayPal account email:
                  </label>
                  <div className="flex-fill d-flex flex-column">
                    <input
                      className={`email-input flex-fill`}
                      required
                      // name="artist_profile_attributes[artist_type]"
                      value={paypalEmail}
                      type={"email"}
                      onChange={(e) => setPaypalEmail(e.target.value)}
                    />
                    <div className="mt-2" style={{ textAlign: "left", color: "#555" }}>
                      Used in your UNIFI Music account for all PRIMO Features, such as TipJar, and Unlimited Distribution Streaming & Sales Royalties
                    </div>
                  </div>
                </div>

                <div className={"btn-btn-invite-container"}>
                  <button disabled={loading} type="submit" className={"btn-btn-invite-submit"} style={{ border: "none" }}>
                    Invite Now
                  </button>
                </div>
                {loading && <Spinner as="span" animation="border" size="md" variant="light" style={{ marginRight: 20, marginTop: 10 }} />}
                {serverError && <div className={"server-error"} dangerouslySetInnerHTML={{ __html: serverError }} />}
              </div>
            </form>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default ModelContainer;
